export default "__VITE_ASSET__BcrzXz4u__"